import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const BENEFITS = [
  {
    icon: 'ri-drop-line',
    title: 'Increased Milk Production',
    desc: 'Our specialized feed additives and supplements help dairy cattle reach their full milk yield potential — up to 25% more daily production.',
    color: 'from-accent/20 to-accent/5',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Improved Meat Yield',
    desc: 'Growth booster formulas maximize carcass weight and muscle development, delivering superior ROI for beef and sheep farmers.',
    color: 'from-accent/20 to-accent/5',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Faster Growth Rates',
    desc: 'Optimized amino acid and metabolic support accelerate healthy weight gain, reducing time-to-market by weeks.',
    color: 'from-accent/20 to-accent/5',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Better Animal Health',
    desc: 'Comprehensive immune support, liver protection, and nutritional completeness keep your herd disease-free and thriving year-round.',
    color: 'from-accent/20 to-accent/5',
  },
];

export default function BenefitsSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="py-24 px-4 md:px-8"
      style={{ background: 'linear-gradient(180deg, #0E1218 0%, #0A0F1A 100%)' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className={`text-center mb-16 reveal ${isVisible ? 'visible' : ''}`}>
          <p className="text-accent text-xs font-semibold tracking-[3px] uppercase mb-3">
            Why It Works
          </p>
          <h2 className="font-poppins font-bold text-3xl md:text-5xl text-white">
            Real Outcomes for Your Farm
          </h2>
          <p className="text-text-muted text-lg mt-4 max-w-xl mx-auto leading-relaxed">
            Every product is formulated to deliver measurable improvements in livestock health and productivity.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BENEFITS.map((benefit, i) => (
            <div
              key={i}
              className={`group relative rounded-2xl p-7 border border-white/5 hover:border-accent/30 transition-all duration-400 cursor-default reveal reveal-delay-${i + 1} ${isVisible ? 'visible' : ''}`}
              style={{ background: '#131923' }}
            >
              {/* Icon */}
              <div
                className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${benefit.color} mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${benefit.icon} text-accent text-2xl`} />
              </div>

              <h3 className="font-poppins font-bold text-lg text-white mb-3 leading-tight">
                {benefit.title}
              </h3>
              <p className="text-text-muted text-sm leading-relaxed">{benefit.desc}</p>

              {/* Bottom accent */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-400 rounded-b-2xl origin-left" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
